var _mask, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamShutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 24,
    viewBox: "0 0 280 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_832_3139",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280 0V18L0 18V0L280 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 18V18.5H280.5V18H280ZM0 18H-0.5V18.5H0V18ZM279.5 0V18H280.5V0L279.5 0ZM280 17.5L0 17.5V18.5L280 18.5V17.5ZM0.5 18V0L-0.5 0V18H0.5Z",
    fill: "#CBCBCB",
    mask: "url(#path-1-inside-1_832_3139)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 18,
    transform: "matrix(1 0 0 -1 19 24)",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamShutter);
export default __webpack_public_path__ + "static/media/camShutter.e3c52c28f3e73b368b7b8cf64bbfaaa6.svg";
export { ForwardRef as ReactComponent };